export enum QuestionAndAnswersEnum {
  GoodYouChooseMubi = 'Dobrze, że wybrałeś(aś) kalkulator OC i\u00A0AC Mubi!',
  JoinDriversWithMubiInsurance = 'Dołącz do tysięcy oszczędnych kierowców, którzy ubezpieczyli swój samochód\ndzięki kalkulatorowi ubezpieczeń Mubi!',
}
